import { loadViewComponent } from "@sinch/core/tools/viewLoader";
import { ClientReminderDialog } from "./ClientReminderDialog";

loadViewComponent(ClientReminderDialog, ".react-entrypoint-ClientReminderDialog");
